import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isProductOneOf } from './is-product-one-of';

export function isEligibleForExploreEditionBenefitsModalWithPDE({
	product,
	edition,
	isInTrial,
	hasPaymentDetailsEntered,
	invoiceableStatus,
}: EditionAwarenessContextType): boolean {
	if (
		edition === 'standard' &&
		isInTrial &&
		isProductOneOf(product, ['jira-service-management', 'jira-customer-service']) &&
		(hasPaymentDetailsEntered || invoiceableStatus === 'INVOICEABLE') &&
		fg('jsmgrowth-466_star_killswitch')
	) {
		return true;
	}

	return false;
}
